var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64577 10.441L10.441 2.64577C11.302 1.78474 12.698 1.78474 13.559 2.64577L21.3542 10.441C22.2153 11.302 22.2153 12.698 21.3542 13.559L13.559 21.3542C12.698 22.2153 11.302 22.2153 10.441 21.3542L2.64577 13.559C1.78474 12.698 1.78474 11.302 2.64577 10.441ZM13.7303 8.16969C13.4374 7.87679 12.9626 7.87679 12.6697 8.16969C12.3768 8.46258 12.3768 8.93745 12.6697 9.23035L14.1893 10.75H11C9.48122 10.75 8.25 11.9812 8.25 13.5V14.7C8.25 15.1142 8.58579 15.45 9 15.45C9.41421 15.45 9.75 15.1142 9.75 14.7V13.5C9.75 12.8097 10.3096 12.25 11 12.25H14.1893L12.6697 13.7697C12.3768 14.0626 12.3768 14.5375 12.6697 14.8303C12.9626 15.1232 13.4374 15.1232 13.7303 14.8303L16.5303 12.0303C16.671 11.8897 16.75 11.6989 16.75 11.5C16.75 11.3011 16.671 11.1103 16.5303 10.9697L13.7303 8.16969Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurn);
export default __webpack_public_path__ + "static/media/turn.254c5723e9e1486b8fb4338ce6fb1ec0.svg";
export { ForwardRef as ReactComponent };